import React from 'react';
import TableCell from './TableCell';

function TableBodyRow({rowData, index, isDraggable, onDragStart, onDragOver, onDrop}) {
    return (
        <tr
            className={`sl-items-center sl-border-0 sl-border-b ${isDraggable ? 'sl-cursor-grab-i' : ''}`}
            draggable={isDraggable}
            onDragStart={isDraggable ? (e) => onDragStart(e, index) : null}
            onDragOver={isDraggable ? (e) => onDragOver(e) : null}
            onDrop={isDraggable ? (e) => onDrop(e, index) : null}
        >
            {Object.values(rowData).map((value, index) => (
                <TableCell key={index} content={value.data}
                           classes={value.classes}
                           contentClasses={value.contentClasses}
                           onClick={value.onClick}
                />
            ))}
        </tr>
    );
}

export default TableBodyRow;
